import { defineComponent } from 'vue'

import VTableHeaderCell from '@/components/common/table/VTableHeaderCell'

import useLocalization from '@/composables/localization/useLocalization'
import useBookingListView from '@/composables/views/booking-list/useBookingListView'

import BookingListTableRow from './BookingListTableRow'

export default defineComponent(() => {
  const { localeTexts } = useLocalization()
  const { bookingListQuery } = useBookingListView()
  return () => (
    <table class='mt-4 w-full table-fixed'>
      <thead class='table-header-group border-b border-neutral-300'>
        <tr>
          <VTableHeaderCell class='w-full'>
            {localeTexts.value['agent-main-booking-list-booking-id-th']}
          </VTableHeaderCell>
          <VTableHeaderCell class='w-[276px]'>
            {localeTexts.value['agent-main-booking-list-name-th']}
          </VTableHeaderCell>
          <VTableHeaderCell class='w-[100px]'>
            VIP
          </VTableHeaderCell>
          <VTableHeaderCell class='w-[276px]'>
            {localeTexts.value['agent-main-booking-list-visit-date-th']}
          </VTableHeaderCell>
          <VTableHeaderCell class='w-[276px]'>
            {localeTexts.value['agent-main-booking-list-status-th']}
          </VTableHeaderCell>
          <td class='w-12' />
        </tr>
      </thead>
      <tbody>
        {bookingListQuery.data.value?.data.map((item) => {
          return (
            <BookingListTableRow
              key={`booking-list-table-row-${item.id}`}
              item={item}
            />
          )
        })}
      </tbody>
    </table>
  )
}
, {
  name: 'BookingListTable'
})
